<script setup>
import { ref, onMounted } from 'vue'
import { useRequestsStore } from '@/stores/storeRequests'
const storeRequests = useRequestsStore()
const socialList = ref([])

onMounted(async () => {
	const res = await storeRequests.getSocialNetworks()
	// фильтруем только те, где есть url
	socialList.value = res.filter((item) => !!item.url)
})
</script>

<template>
	<section class="support" id="support">
		<div class="support__container">
			<div class="support__wrapper">
				<div class="support__bg-elem support__bg-elem-1">
					<img
						loading="lazy"
						src="@/assets/img/support/support_bg-elem-bottom-left.png"
						alt=""
					/>
				</div>

				<div class="support__bg-elem support__bg-elem-2">
					<img
						loading="lazy"
						src="@/assets/img/support/support_bg-elem-top-right.png"
						alt=""
					/>
				</div>

				<div class="support__bg">
					<img loading="lazy" src="@/assets/img/page_bg-second.jpg" alt="" />
				</div>

				<div class="support__text">
					<h2>Возникла проблема с маской?</h2>
					<h4>Не грусти. Просто пиши в WhatsApp.</h4>
				</div>

				<div class="support__link">
					<a
						href="https://wa.me/message/6SJSQIQOUUW6B1"
						rel="nofollow noopener"
						target="_blank"
					>
						<svg width="140" height="140">
							<use :href="`#whatsapp`" />
						</svg>
					</a>
				</div>

				<div class="support__woman">
					<img loading="lazy" src="@/assets/img/support/support_img-1.png" alt="" />
				</div>

				<div class="support__man">
					<img loading="lazy" src="@/assets/img/support/support_img-2.png" alt="" />
				</div>
			</div>
		</div>
	</section>
</template>

<style lang="scss" scoped>
.support {
	padding: 10.8rem 0 6.3rem;

	@media (max-width: 991.98px) {
		padding: 2rem 0.5rem 3rem;
	}

	// .support__container
	&__container {
	}

	// .support__wrapper
	&__wrapper {
		position: relative;
		padding: 4.4rem 5.4rem;
		height: 70.9rem;

		@media (max-width: 991.98px) {
			height: 60.8rem;
			padding: 2rem;
		}
	}

	// .support__bg-elem
	&__bg-elem {
		position: absolute;
		z-index: 1;
		pointer-events: none;
		user-select: none;

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}

	// .support__bg-elem-1
	&__bg-elem-1 {
		width: 10.8rem;
		height: 11rem;
		bottom: -3.2rem;
		left: -5.9rem;

		@media (max-width: 991.98px) {
			bottom: -1.8rem;
			left: -0.9rem;
			width: 5rem;
			height: 5rem;
			transform: rotate(-22deg);
		}
	}

	// .support__bg-elem-2
	&__bg-elem-2 {
		width: 15.1rem;
		height: 13.2rem;
		top: -5.2rem;
		right: -6.2rem;

		@media (max-width: 991.98px) {
			top: -1.5rem;
			right: -1.5rem;
			width: 5.3rem;
			height: 4.7rem;
		}
	}

	// .support__bg
	&__bg {
		border-radius: 4rem;
		overflow: hidden;
		z-index: -1;
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		pointer-events: none;
		user-select: none;

		@media (max-width: 991.98px) {
			border-radius: 2rem;
		}

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	// .support__text
	&__text {
		width: 100%;
		max-width: 49.4rem;

		@media (max-width: 991.98px) {
			max-width: 100%;
			text-align: center;
		}

		h2 {
			font-weight: 400;
			font-size: 11rem;
			// line-height: 10.1rem;
			line-height: 92%;
			text-transform: lowercase;
			color: #000;
			text-align: left;

			@media (max-width: 991.98px) {
				font-size: 3.7rem;
				// line-height: 3.3rem;
				line-height: 90%;
				max-width: 17.4rem;
				margin: 0 auto;
				text-align: center;
			}
		}

		h4 {
			max-width: 42.7rem;
			margin-top: 3rem;
			font-weight: 400;
			font-size: 4.6rem;
			// line-height: 5.3rem;
			line-height: 116%;
			text-transform: lowercase;

			@media (max-width: 991.98px) {
				font-size: 2.4rem;
				max-width: 24.1rem;
				margin: 1.7rem auto 0;
			}
		}
	}

	// .support__link
	&__link {
		position: absolute;
		top: 11rem;
		right: 38.7rem;
		z-index: 10;
		width: 14.5rem;
		height: 14.5rem;
		transform: rotate(13deg);

		@media (max-width: 991.98px) {
			right: auto;
			top: 30.6rem;
			left: 20.5%;
			transform: translateX(-50%) rotate(13deg);
			width: 8rem;
			height: 8rem;
		}

		&::after {
			content: '';
			position: absolute;
			width: 135%;
			height: 135%;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			background-image: url('@/assets/img/social-texture.png');
			background-repeat: no-repeat;
			background-position: center;
			background-size: contain;
			z-index: -1;
		}

		svg {
			width: 100%;
			height: 100%;
		}
	}

	// .support__woman
	&__woman {
		position: absolute;
		bottom: -7rem;
		width: 83rem;
		height: 86.9rem;

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}

		@media (min-width: 991.98px) {
			left: 48.2%;
			transform: translateX(-50%);
		}

		@media (max-width: 991.98px) {
			width: 38.5rem;
			height: 39.8rem;
			bottom: -3.2rem;
			right: -14.2rem;
			transform: scale(-1, 1);
		}
	}

	// .support__man
	&__man {
		position: absolute;
		right: 0;
		top: 0;
		width: 55rem;
		height: 55rem;

		@media (max-width: 991.98px) {
			width: 20rem;
			height: 19rem;
			right: auto;
			top: 19.7rem;
			left: 47.3%;
			transform: translateX(-50%) rotate(-52deg);
		}

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}
}
</style>
